import { Adapter as c, getAdapter as o } from "../../../adapter.js";
import { KioskConfigurationDisabledAdapter as l } from "./kioskConfigurationDisabled/kioskConfigurationDisabled.adapter.js";
import { KioskConfigurationModel as f } from "./kioskConfiguration.model.js";
import { KioskConfigurationCommonAdapter as d } from "./kioskConfigurationCommon/kioskConfigurationCommon.adapter.js";
import { KioskConfigurationHomeAdapter as u } from "./kioskConfigurationHome/kioskConfigurationHome.adapter.js";
import { KioskConfigurationInactiveAdapter as A } from "./kioskConfigurationInactive/kioskConfigurationInactive.adapter.js";
import { KioskConfigurationServiceAdapter as g } from "./kioskConfigurationService/kioskConfigurationService.adapter.js";
import { BaseTimeSlotAdapter as v } from "../../timeSlots/baseTimeSlot.adapter.js";
import { SpecialDayTimeSlotAdapter as S } from "../../timeSlots/specialDayTimeSlot.adapter.js";
import { SpecialHoursPerServiceSlotAdapter as b } from "../../timeSlots/specialHoursPerServiceSlot.adapter.js";
class x extends c {
  adapt(e) {
    var t, p, m;
    const s = o(v), n = o(S), a = o(b), r = o(d).adapt(e.common);
    return new f({
      home: o(u).adapt(e.home),
      service: o(g).adapt(e.service),
      common: r,
      inactive: o(A).adapt(e.inactive),
      disabled: o(l).adapt(e.disabled),
      timetable: {
        openingHours: (((t = e == null ? void 0 : e.timetable) == null ? void 0 : t.opening_hours) ?? []).map((i) => s.adapt({
          ...i,
          timezone: r.settings.timezone
        })),
        specialDays: (((p = e == null ? void 0 : e.timetable) == null ? void 0 : p.special_days) ?? []).map((i) => n.adapt({
          ...i,
          timezone: r.settings.timezone
        })),
        specialHoursPerService: (((m = e == null ? void 0 : e.timetable) == null ? void 0 : m.special_hours_per_service) ?? []).map((i) => a.adapt({
          ...i,
          timezone: r.settings.timezone
        }))
      }
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  x as KioskConfigurationAdapter
};
//# sourceMappingURL=kioskConfiguration.adapter.js.map
